import { Stack } from "@mui/material";
import { categories } from "../utils/constants.js"; // api

const MuiSidebar = ({ selectedCategory, setselectedCategory }) => (
  <Stack
    direction="row"
    sx={{
      overflowY: "auto",
      height: { xs: "auto", md: "95%" },
      flexDirection: { md: "column" },
    }}
  >
    {categories.map((category) => (
      <button
        key={category.name}
        className="category-btn"
        onClick={() => setselectedCategory(category.name)}
        style={{
          color: "white",
          background: category.name === selectedCategory && "#FC1503",
        }}
      >
        <span
          style={{
            color: category.name === selectedCategory ? "white" : "red",
            marginRight: "10px",
          }}
        >
          {category.icon}
        </span>
        <span
          style={{
            opacity: category.name === selectedCategory ? "1" : "0.7",
          }}
        >
          {category.name}
        </span>
      </button>
    ))}
  </Stack>
);

export default MuiSidebar;
